import { FC } from 'react';
import { ComuniChannel } from '../../templates/catalog';

const CHANNEL_LABELS: Record<ComuniChannel, string> = {
  whatsapp: 'WhatsApp',
  sms: 'SMS',
  email: 'Email',
};

const CHANNEL_DOT_STYLES: Record<ComuniChannel, string> = {
  whatsapp: 'bg-emerald-500',
  sms: 'bg-sky-600',
  email: 'bg-cyan-600',
};

const CHANNEL_TEXT_STYLES: Record<ComuniChannel, string> = {
  whatsapp: 'text-emerald-700',
  sms: 'text-sky-700',
  email: 'text-cyan-700',
};

export const ChannelIndicator: FC<{ channel: ComuniChannel }> = ({ channel }) => (
  <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${CHANNEL_TEXT_STYLES[channel]}`}>
    <span className={`size-1.5 shrink-0 rounded-full ${CHANNEL_DOT_STYLES[channel]}`} aria-hidden />
    {CHANNEL_LABELS[channel]}
  </span>
);

export { CHANNEL_LABELS };
